// extracted by mini-css-extract-plugin
export default {"collapseBtn":"CollapseBox_collapseBtn__JN0gr"};